import store from 'store'
import McActions from 'store/redux/mc'

export default socket => {
    socket.on('mc_new_game_template', response => {
        console.tron.log('SOCKET RECEIVED - mc_new_game_template:')
        console.tron.log(response)
        store.dispatch(McActions.handleNewGameTemplateData(response))
    })
    socket.on('mc_new_game', response => {
        console.tron.log('SOCKET RECEIVED - mc_new_game:')
        console.tron.log(response)
        store.dispatch(McActions.handleNewGameData(response))
    })
    socket.on('mc_game_bots_default_values', response => {
        console.tron.log('SOCKET RECEIVED - mc_game_bots_default_values:')
        console.tron.log(response)
        store.dispatch(McActions.handleBotsDefaultValues(response))
    })
    socket.on('mc_game_bots_updated', response => {
        console.tron.log('SOCKET RECEIVED - mc_game_bots_updated:')
        console.tron.log(response)
        store.dispatch(McActions.handleGameBotsUpdated(response))
    })
    socket.on('mc_game', response => {
        console.tron.log('SOCKET RECEIVED - mc_game:')
        console.tron.log(response)
        store.dispatch(McActions.handleGameData(response))
    })
    socket.on('mc_game_log', response => {
        console.tron.log('SOCKET RECEIVED - mc_game_log:')
        console.tron.log(response)
        store.dispatch(McActions.handleGameLogData(response))
    })
    socket.on('mc_decisions_list', response => {
        console.tron.log('SOCKET RECEIVED - mc_decisions_list:')
        console.tron.log(response)
        store.dispatch(McActions.handleGameList(response))
    })
    socket.on('mc_decisions_csv', response => {
        console.tron.log('SOCKET RECEIVED - mc_decisions_csv:')
        console.tron.log(response)
        store.dispatch(McActions.handleGameCSV(response))
    })
    socket.on('mc_error', response => {
        console.tron.log('SOCKET RECEIVED - mc_error:')
        console.tron.log(response)
        store.dispatch(McActions.handleServerError(response))
    })
}



// WEBPACK FOOTER //
// src/api/listeners/mc.js